/**
 * Explain button + tooltip
 */

import * as React from "react";
import "../../../../assets/scss/components/toc/orderPlacement/generic/opExplainButton.scss";

export interface IOpTooltip {
	heading: string;
	description: string;
}

export interface IOpExplainButtonProps {
	tooltipData: Array<IOpTooltip>; // array of heading, description
}

const OpExplainButton: React.FC<IOpExplainButtonProps> = props => {
	const [showTooltip, setShowTooltip] = React.useState(false);

	return (
		<span className="explain_cont">
			<button className="explain" onClick={() => setShowTooltip(true)}>
				Explain
			</button>

			{/* when tooltip is open show overlay and content */}
			{/* Overlay covers the whole screen. When overlay is clicked, close the tooltip. */}
			{showTooltip && <div className="dropdown_overlay" onClick={() => setShowTooltip(false)} />}

			{/* Tooltip */}
			<div className={"tooltip" + (showTooltip ? " active" : "")}>
				{props.tooltipData.map(data => (
					<React.Fragment key={data.heading}>
						<h2>{data.heading}</h2>
						<p>{data.description}</p>
					</React.Fragment>
				))}
			</div>
		</span>
	);
};

export default OpExplainButton;
